import React, { useState } from 'react';
import { sendPasswordReset } from '../../utils/auth';
import './forgotPassword.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [resetting, setResetting] = useState(false);

  const handleResetPassword = async () => {
    setResetting(true);
    setMessage('');
    try {
      await sendPasswordReset(email);
      setMessage('Password reset email sent! Please check your email.');
    } catch (error: any) {
      if (error.code === 'auth/invalid-email') {
        setMessage('Invalid email address.');
      } else {
        setMessage('Failed to send reset password email. Please try again later.');
      }
      console.error('Error sending password reset email:', error);
    } finally {
      setResetting(false);
    }
  };

  return (
    <div className="forgot-password-container">
      <h2>Forgot Password</h2>
      <form className="forgot-password-form">
        <label>Email</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          disabled={resetting}
        />
        <button
          type="button"
          onClick={handleResetPassword}
          disabled={resetting}
        >
          {resetting ? 'Resetting...' : 'Reset Password'}
        </button>
      </form>
      {message && <div className="message">{message}</div>}
    </div>
  );
};

export default ForgotPassword;